export default __webpack_public_path__ + "static/media/error-filled.d6b75c0d.svg";